export const APP_NAME = process.env.REACT_APP_NAME
export const MOUNTING_POINT_ID = process.env.REACT_APP_MOUNTING_POINT_ID
export const VERSION = process.env.REACT_APP_VERSION
